import React from "react";

const counsellingFeatures = [
  {
    title: "NEET UG Rank Predictor",
    desc: "Predict your expected NEET UG rank based on marks and previous year trends.",
    icon: "📊",
  },
  {
    title: "College Predictor",
    desc: "Find MBBS, BDS and AYUSH colleges matching your rank, category and state.",
    icon: "🏥",
  },
  {
    title: "Cut-off & Allotment Data",
    desc: "Check previous year cut-off ranks, rounds and allotment details.",
    icon: "📈",
  },
  {
    title: "Fee, Bond & Stipend",
    desc: "Compare college fees, service bond, rural bond and stipend details.",
    icon: "💰",
  },
  {
    title: "Seat Matrix",
    desc: "Explore AIQ, state quota, deemed, private and government seat availability.",
    icon: "🪑",
  },
  {
    title: "Choice Filling Support",
    desc: "Build a smart preference list for MCC and state counselling rounds.",
    icon: "✅",
  },
  {
    title: "Document Verification",
    desc: "Get complete guidance for required documents and verification process.",
    icon: "📄",
  },
  {
    title: "1:1 Counselling Guidance",
    desc: "Connect with experts for personalized admission and counselling support.",
    icon: "👨‍⚕️",
  },
];

export default function Explore() {
  return (
    <section className="w-full max-w-6xl mx-auto px-4 py-12">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3">
          One Platform for Smarter Decisions in Every{" "}
          <span className="text-[#ff9245]">NEET UG Counselling Round.</span>
        </h2>

        <p className="text-gray-600 text-base md:text-lg max-w-3xl mx-auto">
          From rank prediction to college selection, cut-off analysis, document
          verification and choice filling — NEET Support helps you plan every
          step with confidence.
        </p>
      </div>

      <div className="mb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {counsellingFeatures.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white border border-[#ff9245]/60 rounded-xl p-6 flex flex-col shadow-sm hover:shadow-md transition-all duration-300 items-start"
            >
              <div className="mb-4 flex items-center justify-center w-11 h-11 rounded-lg bg-[#ff9245] text-white text-xl">
                {feature.icon}
              </div>

              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                {feature.title}
              </h4>

              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}